import React from 'react';
import ManagerHeader from "../components/_layout/ManagerHeader";
import { BadgeProvider } from "../context/badge";

const ManagerLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <BadgeProvider>
            <div className='bg-melon-light flex flex-col h-screen overflow-hidden font-medium text-melon-black font-acrom'>
                <div className='h-fit px-16 pt-4 pb-5 bg-melon-white-darker'>
                    <ManagerHeader />
                </div>
                <div className='flex-1 flex px-16 mb-2 overflow-hidden'>
                    {children}
                </div>
            </div>
        </BadgeProvider>
    );
};

export default ManagerLayout;